var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.845 2.94812L11.505 2.28812C12.285 1.50813 13.6425 1.50813 14.4225 2.28812L14.955 2.82062C15.345 3.21062 15.5625 3.72813 15.5625 4.27562C15.5625 4.82313 15.345 5.34812 14.955 5.73063L14.295 6.39062L10.845 2.94062V2.94812ZM10.05 3.74312L3.2175 10.5756C3 10.7931 2.865 11.0781 2.8425 11.3856L2.64 13.5831C2.6175 13.8606 2.715 14.1306 2.91 14.3331C3.09 14.5131 3.3225 14.6106 3.57 14.6106H3.6525L5.85 14.4081C6.1575 14.3781 6.4425 14.2431 6.66 14.0256L13.4925 7.19312L10.0425 3.74312H10.05ZM17.0625 17.0031C17.0625 16.6956 16.8075 16.4406 16.5 16.4406H1.5C1.1925 16.4406 0.9375 16.6956 0.9375 17.0031C0.9375 17.3106 1.1925 17.5656 1.5 17.5656H16.5C16.8075 17.5656 17.0625 17.3106 17.0625 17.0031Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.a119d2f8df90a7e417b0c3ce4ea323c6.svg";
export { ForwardRef as ReactComponent };